import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { LocationsToAddInJobs } from "../../domain";
import { JobsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetLocationsToAddInJobUsecase implements UseCase<string, LocationsToAddInJobs[]> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: string): Observable<LocationsToAddInJobs[]> {
    return this.jobRepository.getLocationsToAddInJob(params);
  }

}
